<a class="tariff" href="javascript:void(0)"  routerLink="/tariff">Тарифы</a>
<nb-menu (click)="onMenuClick()" [items]="menuItems" tag="menu"></nb-menu>

<div class="side-nav__users align-items-center" routerLink="/page/settings">
    <div class="side-nav__users_avatar">
        <nb-icon class="full-height avatar" icon="userAvatar"></nb-icon>
    </div>
    <div class="side-nav__users_setting">
        <a *ngIf="user$ | async as user" class="header-text-item"
        >{{getName(user)}}</a>
    </div>
    <div class="side-nav__logout">
        <nb-icon (click)="logout()" class="cup" icon="logout"></nb-icon>
    </div>
</div>

